"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var BaseInputWrapper = /** @class */ (function (_super) {
    __extends(BaseInputWrapper, _super);
    function BaseInputWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseInputWrapper.prototype.findNativeInput = function () {
        return this.find('.awsui-input');
    };
    BaseInputWrapper.prototype.focus = function () {
        this.findNativeInput().fireEvent(new dom_1.FocusEvent('focusin'));
    };
    BaseInputWrapper.prototype.blur = function () {
        this.findNativeInput().fireEvent(new dom_1.FocusEvent('focusout'));
    };
    /**
     * Sets the value of the component.
     *
     * This does not fire a change event, you need to call `fireChangeEvent` if you rely on change events.
     *
     * @param value The value the input is set to.
     */
    BaseInputWrapper.prototype.setInputValue = function (value) {
        var element = this.findNativeInput().getElement();
        element.value = value;
        this.findNativeInput().fireEvent(new dom_1.InputEvent('input'));
    };
    BaseInputWrapper.prototype.fireChangeEvent = function () {
        this.findNativeInput().fireEvent(new dom_1.InputEvent('change'));
    };
    __decorate([
        dom_1.usesDom
    ], BaseInputWrapper.prototype, "focus", null);
    __decorate([
        dom_1.usesDom
    ], BaseInputWrapper.prototype, "blur", null);
    __decorate([
        dom_1.usesDom
    ], BaseInputWrapper.prototype, "setInputValue", null);
    __decorate([
        dom_1.usesDom
    ], BaseInputWrapper.prototype, "fireChangeEvent", null);
    return BaseInputWrapper;
}(dom_1.ComponentWrapper));
exports.default = BaseInputWrapper;
//# sourceMappingURL=awsui-base-input.js.map